<ng-content select="header"></ng-content>
<router-outlet></router-outlet>
<ng-content select="footer"></ng-content>
